// extracted by mini-css-extract-plugin
export var border = "_1d-8";
export var brand = "_1d-t";
export var button = "_1d-l";
export var center = "_1d-a";
export var centered = "_1d-6";
export var closeButton = "_1d-c";
export var disabledWrapper = "_1d-m";
export var error = "_1d-p";
export var extraLarge = "_1d-4";
export var extraSmall = "_1d-1";
export var fill = "_1d-i";
export var footer = "_1d-h";
export var footerAction = "_1d-j";
export var footerButtons = "_1d-k";
export var header = "_1d-7";
export var headerWithClose = "_1d-d";
export var icon = "_1d-o";
export var info = "_1d-s";
export var inline = "_1d-9";
export var large = "_1d-3";
export var main = "_1d-e";
export var modal = "_1d-0";
export var nearFull = "_1d-5";
export var neutral = "_1d-u";
export var noPadding = "_1d-g";
export var none = "_1d-v";
export var scrollable = "_1d-f";
export var small = "_1d-2";
export var success = "_1d-r";
export var tight = "_1d-n";
export var titleIcon = "_1d-b";
export var warn = "_1d-q";